import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill={color} fillRule="evenodd" d="M.5 8c0-2.07 0-3.105.286-3.939A5.276 5.276 0 0 1 4.061.786C4.895.5 5.93.5 8 .5c2.07 0 3.105 0 3.939.286a5.276 5.276 0 0 1 3.275 3.275C15.5 4.895 15.5 5.93 15.5 8c0 2.07 0 3.105-.286 3.939a5.277 5.277 0 0 1-3.275 3.275c-.834.286-1.869.286-3.939.286-2.07 0-3.105 0-3.939-.286a5.276 5.276 0 0 1-3.275-3.275C.5 11.105.5 10.07.5 8Zm10.313 0c0 .31-.252.563-.563.563H8.562v1.687a.562.562 0 1 1-1.124 0V8.562H5.75a.563.563 0 0 1 0-1.124h1.688V5.75a.563.563 0 0 1 1.125 0v1.688h1.687c.31 0 .563.251.563.562Z" clipRule="evenodd"/>
    </svg>
)

export default class IconPlusSquare extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
